export default __webpack_public_path__ + "static/media/theme-white.191cdc85.svg";